<template>
  <section class="section-base form-section-base">
    <v-container>
      <div class="form-base__title">
        Прошу передать электронный документ (пакет электронных документов) и
        выдать свидетельство о направлении/передаче электронного документа
        (пакета электронных документов):
      </div>
      <div class="form-section-base__controls">
        <v-row>
          <v-col>
            <v-radio-group v-model="role" row>
              <v-radio label="Физическое лицо" :value="Role.PERSON" />
              <v-radio label="Юридическое лицо" :value="Role.ORGANIZATION" />
              <v-radio
                label="Иностранное юридическое лицо"
                :value="Role.FOREIGN_ORGANIZATION"
              />
            </v-radio-group>
          </v-col>
        </v-row>
      </div>

      <Person v-if="role === Role.PERSON" :v="$v.person" />

      <Organization v-if="role === Role.ORGANIZATION" :v="$v.organization" />

      <ForeignOrganization
        v-if="role === Role.FOREIGN_ORGANIZATION"
        :v="$v.foreignOrganization"
      />

      <AttachDocumentMultiple
        class="py-3"
        v-model="$v.transferDocuments.$model"
        :error-messages="getValidationErrorText($v.transferDocuments)"
      />

      <Footer
        @next-btn-click="btnSaveClickHandler(StepDirection.NEXT)"
        @prev-btn-click="btnSaveClickHandler(StepDirection.PREV)"
        :loading-next="loadingNext"
      />
    </v-container>
  </section>
</template>

<script>
import cloneDeep from 'clone-deep';
import deepmerge from 'deepmerge';
import { required } from 'vuelidate/lib/validators';

import { Role } from '@/utils/dictionaries';
import { checkInvalid, leaveStep } from '@/utils/services';
import Footer from '@/components/services/elements/Footer';
import { getValidationErrorText } from '@/utils/validate';
import { ServicesModule } from '@/store/modules/services';
import AttachDocumentMultiple from '@/components/base/AttachDocument/AttachDocumentMultiple';
import { StepDirection, StepName } from '@/types/services';
import Person, { personModel, personValidation } from './Person';
import Organization, {
  organizationModel,
  organizationValidation,
} from './Organization';
import ForeignOrganization, {
  foreignOrganizationModel,
  foreignOrganizationValidation,
} from './ForeignOrganization';
import { TransferElDocsStep } from '@/constants';

export default {
  name: 'Addressee',
  props: {
    loadingNext: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    Person,
    Organization,
    ForeignOrganization,
    Footer,
    AttachDocumentMultiple,
  },
  data: () => ({
    StepDirection,
    StepName,
    leaveStep,
    Role,
    getValidationErrorText,
    invalidFields: [],
    role: Role.PERSON,
    person: cloneDeep(personModel),
    organization: cloneDeep(organizationModel),
    foreignOrganization: cloneDeep(foreignOrganizationModel),
    transferDocuments: [],
  }),
  validations() {
    return {
      person: personValidation,
      organization: organizationValidation,
      foreignOrganization: foreignOrganizationValidation,
      transferDocuments: {
        DOCUMENTS_MIN_LENGTH: required,
      },
    };
  },
  created() {
    this.prefillDraft();
  },
  methods: {
    prefillDraft() {
      if (!ServicesModule.statement.subjects.addressee) {
        return;
      }

      const statementStore = cloneDeep(
        ServicesModule.statement.subjects.addressee
      );

      if (statementStore[Role.PERSON]) {
        this.role = Role.PERSON;
        this[Role.PERSON] = deepmerge(personModel, statementStore[Role.PERSON]);
      }

      if (statementStore[Role.ORGANIZATION]) {
        this.role = Role.ORGANIZATION;
        this[Role.ORGANIZATION] = deepmerge(
          organizationModel,
          statementStore[Role.ORGANIZATION]
        );

        if (this[Role.ORGANIZATION].inn) {
          this[Role.ORGANIZATION].hasOgrn = false;
        }
      }

      if (statementStore[Role.FOREIGN_ORGANIZATION]) {
        this.role = Role.FOREIGN_ORGANIZATION;
        this[Role.FOREIGN_ORGANIZATION] = deepmerge(
          foreignOrganizationModel,
          statementStore[Role.FOREIGN_ORGANIZATION]
        );

        if (this[Role.FOREIGN_ORGANIZATION].inn) {
          this[Role.FOREIGN_ORGANIZATION].hasRegNumber = false;
        }
      }

      this.transferDocuments = cloneDeep(
        ServicesModule.statement.transferDocuments
      );
    },

    assemblyModel() {
      const model = {
        addressee: {
          [this.role]: cloneDeep(this[this.role]),
        },
        transferDocuments: cloneDeep(this.transferDocuments),
      };

      if (model.addressee[Role.ORGANIZATION]) {
        if (model.addressee[Role.ORGANIZATION].hasOgrn) {
          model.addressee[Role.ORGANIZATION].inn = null;
        } else {
          model.addressee[Role.ORGANIZATION].ogrn = null;
        }

        delete model.addressee[Role.ORGANIZATION].hasOgrn;
      }

      if (model.addressee[Role.FOREIGN_ORGANIZATION]) {
        if (model.addressee[Role.FOREIGN_ORGANIZATION].hasRegNumber) {
          model.addressee[Role.FOREIGN_ORGANIZATION].inn = null;
        } else {
          model.addressee[Role.FOREIGN_ORGANIZATION].regNumber = null;
        }

        delete model.addressee[Role.FOREIGN_ORGANIZATION].hasRegNumber;
      }

      return model;
    },

    touchFields() {
      this.invalidFields = [];

      this.$v[this.role].$touch();
      checkInvalid(this.$v[this.role], this.invalidFields);

      this.$v.transferDocuments.$touch();
      checkInvalid(this.$v.transferDocuments, this.invalidFields);
    },

    btnSaveClickHandler(direction) {
      leaveStep({
        stepThis: this,
        direction,
        step: TransferElDocsStep.ADDRESSEE,
      });
    },
  },
};
</script>
